export const languageLabelMap = {
  en: 'english',
  fr: 'french'
}
